import { Stack, Typography } from "@mui/material";
import ActionButton from "components/Buttons/ActionButton";
import FeedbackProviderContext from "components/FeedbackProvider/context/FeedbackProviderContext";
import useProject from "hooks/useProject";
import { useContext } from "react";
import colors from "theme/base/colors";
import { flexCentered } from "theme/base/flex";

export default function LegacyImportBanner() {
  const { imported } = useProject();
  const { setFeedback, setShowModal } = useContext(FeedbackProviderContext);

  return (
    imported && (
      <Stack
        sx={{
          backgroundColor: colors.vidletColors.orange,
          ...flexCentered,
          height: "3rem",
        }}
        direction="row"
        spacing={2}
      >
        <Typography
          variant="overline"
          component="span"
          sx={{
            color: "white !important",
          }}
        >
          This is an imported Unicorn project. Functionality will be limited.
        </Typography>
        <ActionButton
          size="small"
          onClick={() => {
            setFeedback(`Please add support for the following feature: \n\n`);
            setShowModal(true);
          }}
        >
          request a missing feature
        </ActionButton>
      </Stack>
    )
  );
}
